import React from 'react';
import styles from './Seperator.module.scss';

export const Separator = (props: {
  color?: string;
  orientation?: 'horizontal' | 'vertical';
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={styles.separator}
      style={{
        height: props.orientation === 'horizontal' ? '1px' : '20px',
        width: props.orientation === 'horizontal' ? '100%' : '1px',
        backgroundColor: props.color,
        ...props.style,
      }}
    />
  );
};

export default Separator;
